import { Component, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { AssetsManagementService } from '../../services/assets-management.service';
import { DashboardComponent } from '../dashboard.component';

@Component({
  selector: 'app-asset-terms-of-uses',
  templateUrl: './asset-terms-of-uses.component.html',
  styleUrls: ['./asset-terms-of-uses.component.css']
})
export class AssetTermsOfUsesComponent implements OnInit {
  @ViewChild('documentContent') content;
  @Input('assetIdForUses') assetId;
  @Input('whichModal') whichModal;
  @Output() closedModalAssetTermsEvent = new EventEmitter<any>();
  currentDate;
  name;
  designation;
  acceptUses;
  signAfterAccept;
  constructor(private modalService: NgbModal, private assetsManagementService: AssetsManagementService,
    private commonMessageService:CommonMessageService) {
    const current = new Date();
    this.currentDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
  }

  ngOnInit(): void {
    this.name = localStorage.getItem('userFname') + ' ' + localStorage.getItem('userLname');
    this.designation = localStorage.getItem('userDesignation');
    console.log('current date', this.currentDate)
  }

  ngAfterViewInit() {
    this.openModal(this.content)
    console.log('assetId of dashboard', this.assetId);
  }

  modalReference:any;
  closeResult='';
  openModal(content) {
    // let ngbModalOptions: NgbModalOptions = {
    //   ariaLabelledBy: 'modal-basic-title',
    //   size: 'lg',
    //   windowClass: 'animate__animated animate__slideInUp animate__faster',
    //   backdrop: 'static',
    //   keyboard: false,
    // };
    // this.modalService.open(content, ngbModalOptions).result.then(
    //   (result) => {
    //     // this.closeResult = `Closed with: ${result}`;
    //   },
    //   (reason) => {
    //     // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //   }
    // );


    this.modalReference = this.modalService.open(content,{backdrop : false,size: 'lg'});
    this.modalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  okButtonClick() {
    console.log('acceptUses', this.acceptUses, 'signAfterAccept', this.signAfterAccept);
    if (this.acceptUses == null || this.acceptUses == undefined || this.acceptUses == false ||
      this.signAfterAccept == null || this.signAfterAccept == undefined || this.signAfterAccept == false) {
        this.commonMessageService.swalAlertWithoutIcon('','Please accept terms of usage and sign the document.');
    } else {
      this.assetsManagementService.saveAssetTermsOfUses(this.assetId).subscribe((resp: any) => {
        console.log('termsof uses response', resp);
        this.closeModal();
      });
    }
  }

  closeModal() {
    this.modalReference.close();
    this.closedModalAssetTermsEvent.emit({ whichModal: this.whichModal });
  }
}
